import { ReadAllResponse, uuid } from "@/interfaces";
import { PhotoWorkflow } from "@/models/photo-workflow.model";
import { PhotoWorkflowRepository } from "@/repositories/photo-workflow.repository";

export async function fetchPhotoWorkflow(service: uuid): Promise<ReadAllResponse<PhotoWorkflow>> {
  return PhotoWorkflowRepository.getAll(service);
}

export async function insertPhotoWorkflow({ service, title, description }: { service: uuid; title: string; description?: string | null }): Promise<ReadAllResponse<PhotoWorkflow>> {
  return PhotoWorkflowRepository.create(service, { title, description });
}

export async function orderPhotoWorkflow({ service, slots }: { service: uuid; slots: uuid[] }): Promise<ReadAllResponse<PhotoWorkflow>> {
  return PhotoWorkflowRepository.order(service, slots);
}

export async function removePhotoWorkflow({ service, slot }: { service: uuid; slot: uuid }): Promise<ReadAllResponse<PhotoWorkflow>> {
  return PhotoWorkflowRepository.delete(service, slot);
}
